import React, { Component } from 'react'

class IcRightArrow extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <g fill="#FFF" fillRule="nonzero">
          <path
            fillOpacity=".2"
            d="M11.916 0C5.346 0 0 5.346 0 11.916s5.346 11.917 11.916 11.917 11.917-5.346 11.917-11.917C23.833 5.346 18.488 0 11.916 0z"
          />
          <path d="M15.6 6H8.4A2.4 2.4 0 0 0 6 8.4v7.2A2.4 2.4 0 0 0 8.4 18h7.2a2.4 2.4 0 0 0 2.4-2.4V8.4A2.4 2.4 0 0 0 15.6 6zm-1.2 1.8h1.8v1.8h-1.8V7.8zM12 9.6a2.4 2.4 0 1 1 0 4.8 2.4 2.4 0 0 1 0-4.8zm4.8 6a1.2 1.2 0 0 1-1.2 1.2H8.4a1.2 1.2 0 0 1-1.2-1.2v-4.2h1.26a3.6 3.6 0 1 0 7.08 0h1.26v4.2z" />
        </g>
      </svg>
    )
  }
}

export default IcRightArrow
